export const MIN_COMPETITORS = 1;
export const MAX_COMPETITORS = 4;
/** Catalog Hot Seat boat picker upper bound (same as the engine). */
export const CATALOG_COMPETITOR_MAX = MAX_COMPETITORS;

export function clampCompetitorCount(value: unknown): number {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return MIN_COMPETITORS;
  }

  return Math.min(MAX_COMPETITORS, Math.max(MIN_COMPETITORS, Math.round(value)));
}
